import { useTranslation } from '../../../hooks/useTranslation';
import { AgentMetricsUnit } from '../../../interfaces/Agent';
import AgentMetric from '../AgentMetric/AgentMetric';
import StyledOverAllMetrics from './StyledOverAllMetrics';

interface OverAllMetricsProps {
  meanSuccessRate?: number;
  totalCalls?: number;
  totalDuration?: number;
  isRefreshing?: boolean;
}

const OverAllMetrics: React.FC<OverAllMetricsProps> = ({
  meanSuccessRate = 0,
  totalCalls = 0,
  totalDuration = 0,
  isRefreshing = false,
}) => {
  const { t } = useTranslation();

  return (
    <StyledOverAllMetrics>
      <AgentMetric
        unit={AgentMetricsUnit.MINUTE}
        value={totalDuration}
        label={t('Duration')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
      <AgentMetric
        value={totalCalls}
        label={t('Calls')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
      <AgentMetric
        unit={AgentMetricsUnit.PERCENT}
        value={meanSuccessRate}
        label={t('Success Rate')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
    </StyledOverAllMetrics>
  );
};

export default OverAllMetrics;
